// extracted by mini-css-extract-plugin
export default {"content":"edit-card-modal_content__9g6CZ","childrenContainer":"edit-card-modal_childrenContainer__N-LZ8"};